export default "__VITE_ASSET__BWZt9Z4N__"